/**
 * Утилиты для определения проблемных браузеров
 */

export interface BrowserInfo {
  isProblematic: boolean;
  name: string;
  version: string;
  isEmbedded: boolean;
  userAgent: string;
}

/**
 * Определяет информацию о браузере
 */
export function detectBrowser(): BrowserInfo {
  const userAgent = navigator.userAgent;
  
  // Определяем основные браузеры
  let name = 'Unknown';
  let version = 'Unknown';
  let isEmbedded = false;
  
  // Проверяем на встроенные браузеры приложений
  if (userAgent.includes('TelegramWebApp') || userAgent.includes('Telegram')) {
    name = 'Telegram';
    isEmbedded = true;
  } else if (userAgent.includes('Instagram') || userAgent.includes('IG')) {
    name = 'Instagram';
    isEmbedded = true;
  } else if (userAgent.includes('Facebook') || userAgent.includes('FB')) {
    name = 'Facebook';
    isEmbedded = true;
  } else if (userAgent.includes('WhatsApp')) {
    name = 'WhatsApp';
    isEmbedded = true;
  } else if (userAgent.includes('VKWebApp') || userAgent.includes('VK')) {
    name = 'VKontakte';
    isEmbedded = true;
  } else if (userAgent.includes('Line')) {
    name = 'Line';
    isEmbedded = true;
  } else if (userAgent.includes('WeChat')) {
    name = 'WeChat';
    isEmbedded = true;
  } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
    name = 'Safari';
    const match = userAgent.match(/Version\/(\d+\.\d+)/);
    version = match ? match[1] : 'Unknown';
  } else if (userAgent.includes('Chrome')) {
    name = 'Chrome';
    const match = userAgent.match(/Chrome\/(\d+\.\d+)/);
    version = match ? match[1] : 'Unknown';
  } else if (userAgent.includes('Firefox')) {
    name = 'Firefox';
    const match = userAgent.match(/Firefox\/(\d+\.\d+)/);
    version = match ? match[1] : 'Unknown';
  } else if (userAgent.includes('Edge')) {
    name = 'Edge';
    const match = userAgent.match(/Edge\/(\d+\.\d+)/);
    version = match ? match[1] : 'Unknown';
  }
  
  // Определяем, является ли браузер проблемным
  const isProblematic = isEmbedded || 
    (name === 'Safari' && parseInt(version) < 14) ||
    (name === 'Chrome' && parseInt(version) < 80);
  
  return {
    isProblematic,
    name,
    version,
    isEmbedded,
    userAgent
  };
}

/**
 * Проверяет, поддерживает ли браузер множественную загрузку файлов
 */
export function supportsMultipleFileUpload(): boolean {
  const input = document.createElement('input');
  input.type = 'file';
  input.multiple = true;
  
  // Проверяем поддержку атрибута multiple
  return 'multiple' in input;
}

/**
 * Проверяет, поддерживает ли браузер File API
 */
export function supportsFileAPI(): boolean {
  return !!(window.File && window.FileReader && window.FileList && window.Blob);
}

/**
 * Полная диагностика браузера
 */
export function getBrowserDiagnostics() {
  const browser = detectBrowser();
  const supportsMultiple = supportsMultipleFileUpload();
  const supportsFileAPIValue = supportsFileAPI();
  
  return {
    browser,
    supportsMultiple,
    supportsFileAPI: supportsFileAPIValue,
    isCompatible: supportsMultiple && supportsFileAPIValue && !browser.isProblematic
  };
}
